import { render, staticRenderFns } from "./BaseEmail.vue?vue&type=template&id=869dd3d4&"
import script from "./BaseEmail.vue?vue&type=script&lang=js&"
export * from "./BaseEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports